module.exports = __webpack_public_path__ + "static/media/appetizer-short.9a7be3c5.svg";